import { Link } from 'react-router-dom';
import logo from '../assets/Best_National_Carports-logo-blk.svg';
import PublicFooter from '../components/PublicFooter';

export default function Privacy() {
	const lastUpdated = 'June 9, 2026';

	return (
		<div className="privacy-page min-h-screen bg-white text-slate-800">
			<header className="border-b border-slate-200">
				<div className="max-w-3xl mx-auto px-6 py-5 flex items-center justify-between">
					<Link to="/" className="inline-flex">
						<img
							src={logo}
							alt="Best National Carports Logo"
							className="h-10 w-auto"
						/>
					</Link>
					<Link to="/" className="text-sm text-blue-600 underline">
						Back to Login
					</Link>
				</div>
			</header>
			<main className="max-w-3xl mx-auto px-6 py-12">
				<h1 className="text-3xl font-semibold text-black mb-2">
					Privacy Policy
				</h1>
				<p className="text-sm text-slate-500 mb-10">
					Last updated: {lastUpdated}
				</p>

				<section className="space-y-4 mb-8">
					<p>
						This Privacy Policy describes how Best National Carports
						(&ldquo;we&rdquo;, &ldquo;us&rdquo;, or &ldquo;our&rdquo;) collects,
						uses, and protects your information when you use our mobile
						application and related services (collectively, the
						&ldquo;Service&rdquo;). By using the Service, you agree to the
						practices described in this policy.
					</p>
				</section>

				<section className="space-y-3 mb-8">
					<h2 className="text-xl font-semibold text-black">
						Information We Collect
					</h2>
					<p>
						We may collect information that you provide directly to us, such as
						your name, email address, phone number, and account credentials when
						you register for or use the Service. We may also collect information
						automatically, including device information, log data, and usage
						information related to how you interact with the Service.
					</p>
				</section>

				<section className="space-y-3 mb-8">
					<h2 className="text-xl font-semibold text-black">
						How We Use Your Information
					</h2>
					<p>
						We use the information we collect to provide, maintain, and improve
						the Service; to authenticate users and secure accounts; to
						communicate with you about updates, support, and administrative
						matters; and to comply with legal obligations.
					</p>
				</section>

				<section className="space-y-3 mb-8">
					<h2 className="text-xl font-semibold text-black">
						How We Share Your Information
					</h2>
					<p>
						We do not sell your personal information. We may share information
						with trusted service providers who perform services on our behalf,
						when required by law, or to protect the rights, property, and safety
						of our users and the public. Any third parties with whom we share
						information are required to safeguard it consistent with this
						policy.
					</p>
				</section>

				<section className="space-y-3 mb-8">
					<h2 className="text-xl font-semibold text-black">Data Security</h2>
					<p>
						We implement reasonable technical and organizational measures
						designed to protect your information against unauthorized access,
						loss, or misuse. However, no method of transmission or storage is
						completely secure, and we cannot guarantee absolute security.
					</p>
				</section>

				<section className="space-y-3 mb-8">
					<h2 className="text-xl font-semibold text-black">Data Retention</h2>
					<p>
						We retain your information for as long as your account is active or
						as needed to provide the Service, comply with our legal obligations,
						resolve disputes, and enforce our agreements.
					</p>
				</section>

				<section className="space-y-3 mb-8">
					<h2 className="text-xl font-semibold text-black">Your Rights</h2>
					<p>
						Depending on your location, you may have the right to access,
						correct, or delete your personal information, or to object to or
						restrict certain processing. To exercise these rights, please
						contact us using the information below.
					</p>
				</section>

				<section className="space-y-3 mb-8">
					<h2 className="text-xl font-semibold text-black">
						Children&rsquo;s Privacy
					</h2>
					<p>
						The Service is not directed to children under the age of 13, and we
						do not knowingly collect personal information from children. If you
						believe a child has provided us with personal information, please
						contact us so we can take appropriate action.
					</p>
				</section>

				<section className="space-y-3 mb-8">
					<h2 className="text-xl font-semibold text-black">
						Changes to This Policy
					</h2>
					<p>
						We may update this Privacy Policy from time to time. When we do, we
						will revise the &ldquo;Last updated&rdquo; date at the top of this
						page. Your continued use of the Service after any changes indicates
						your acceptance of the updated policy.
					</p>
				</section>

				<section className="space-y-3 mb-8">
					<h2 className="text-xl font-semibold text-black">Contact Us</h2>
					<p>
						If you have any questions or concerns about this Privacy Policy or
						our data practices, please contact us at{' '}
						<a
							href="mailto:support@bestnationalcarports.com"
							className="text-blue-600 underline"
						>
							support@webdesignpilot.com
						</a>
						.
					</p>
				</section>
			</main>
			<PublicFooter />
		</div>
	);
}
